// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"2bcd4a96","821":"9ef5b67f"}[chunkId] + ".chunk.js";
};